import React from "react";
import "../assets/scss/layoutweb.scss";
import { Link } from "react-router-dom";
import { customersDtls } from "../locales/en";
import { INVOICE } from "../route/paths";

export default function NotFound() {
  return (
    <section className="container-fluid error-page text-center">
      <div className="container">
        <h2>
          {customersDtls?.notFound.item1}
          <span>{customersDtls?.notFound.item2}</span>
          {customersDtls?.notFound.item3}
        </h2>
        <p>{customersDtls?.notFound.oops}</p>
        <div className="d-flex justify-content-center">
          <Link to={INVOICE} className="btn btn-primary">
            {customersDtls?.notFound.goToHomeBtn}
          </Link>
        </div>
      </div>
    </section>
  );
}
